const state = {
  user: {
    avatar: '',
    firstname: '',
    lastname: ''
  },
  overview: {
    items: [],
    total: 0
  }
}

const getters = {
  getUser: state => state.user,
  getUserAvatar: state => state.user.avatar,
  getUserFirstname: state => state.user.firstname,
  getUserLastname: state => state.user.lastname,
  getOverview: state => state.overview.items,
  getOffsetOverview: state => state.overview.items.length,
  getTotalOverview: state => state.overview.total
}

const mutations = {
  UPDATE_USER_AVATAR: (state, string) => {
    state.user.avatar = string
  },
  UPDATE_USER_FIRSTNAME: (state, string) => {
    state.user.firstname = string
  },
  UPDATE_USER_LASTNAME: (state, string) => {
    state.user.lastname = string
  },
  UPDATE_OVERVIEW_ITEMS: (state, array) => {
    state.overview.items = [ ...array ]
  },
  UPDATE_OVERVIEW_TOTAL: (state, number) => {
    state.overview.total = number || 0
  },
  ADD_OVERVIEW_ITEMS: (state, array) => {
    state.overview.items = [...state.overview.items, ...array]
  }
}

const actions = {
  updateUser: ({ commit }, user) => {
    commit('UPDATE_USER_AVATAR', user.avatar)
    commit('UPDATE_USER_FIRSTNAME', user.firstname)
    commit('UPDATE_USER_LASTNAME', user.lastname)
  },
  updateOverview: ({ commit }, overview) => {
    commit('UPDATE_OVERVIEW_ITEMS', overview.items)
    commit('UPDATE_OVERVIEW_TOTAL', overview.total)
  },
  addOverview: ({ commit, dispatch }, overview) => {
    commit('ADD_OVERVIEW_ITEMS', overview.items)
    if (overview.total) commit('UPDATE_OVERVIEW_TOTAL', overview.total)
  }
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
}
